<template>
  <form @submit.prevent="onSubmit">
    <div class="container">

      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label">Names</label>
        </div>
        <div class="field-body">
          <div class="field">
            <p class="control is-expanded">
              <input class="input" type="text" v-model="creative" placeholder="Creative Name">
            </p>
          </div>
          <div class="field">
            <p class="control is-expanded">
              <typeahead placeholder="Advertiser Name" v-model="advertiser" :values="advertisers"/>
            </p>
            <p v-if="advertiserMessage != null" class="help">{{ advertiserMessage }}</p>
          </div>
        </div>
      </div>

      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label">IAB Category</label>
        </div>
        <div class="field-body">
          <div class="field is-narrow">
            <div class="control">
              <div class="select is-fullwidth">
                <select v-model="category">
                  <option></option>
                  <option v-for="category in categoriesArray">{{ category }}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label">Country</label>
        </div>
        <div class="field-body">
          <div class="field">
            <div class="control">
              <div class="select">
                <select v-model="country" placeholder="Select a country...">
                  <option value="">Select a country...</option>
                  <option value="AF">Afghanistan</option>
                  <option value="AX">&Aring;land Islands</option>
                  <option value="AL">Albania</option>
                  <option value="DZ">Algeria</option>
                  <option value="AS">American Samoa</option>
                  <option value="AD">Andorra</option>
                  <option value="AO">Angola</option>
                  <option value="AI">Anguilla</option>
                  <option value="AQ">Antarctica</option>
                  <option value="AG">Antigua and Barbuda</option>
                  <option value="AR">Argentina</option>
                  <option value="AM">Armenia</option>
                  <option value="AW">Aruba</option>
                  <option value="AU">Australia</option>
                  <option value="AT">Austria</option>
                  <option value="AZ">Azerbaijan</option>
                  <option value="BS">Bahamas</option>
                  <option value="BH">Bahrain</option>
                  <option value="BD">Bangladesh</option>
                  <option value="BB">Barbados</option>
                  <option value="BY">Belarus</option>
                  <option value="BE">Belgium</option>
                  <option value="BZ">Belize</option>
                  <option value="BJ">Benin</option>
                  <option value="BM">Bermuda</option>
                  <option value="BT">Bhutan</option>
                  <option value="BO">Bolivia, Plurinational State of</option>
                  <option value="BA">Bosnia and Herzegovina</option>
                  <option value="BW">Botswana</option>
                  <option value="BV">Bouvet Island</option>
                  <option value="BR">Brazil</option>
                  <option value="IO">British Indian Ocean Territory</option>
                  <option value="BN">Brunei Darussalam</option>
                  <option value="BG">Bulgaria</option>
                  <option value="BF">Burkina Faso</option>
                  <option value="BI">Burundi</option>
                  <option value="KH">Cambodia</option>
                  <option value="CM">Cameroon</option>
                  <option value="CA">Canada</option>
                  <option value="CV">Cape Verde</option>
                  <option value="KY">Cayman Islands</option>
                  <option value="CF">Central African Republic</option>
                  <option value="TD">Chad</option>
                  <option value="CL">Chile</option>
                  <option value="CN">China</option>
                  <option value="CX">Christmas Island</option>
                  <option value="CC">Cocos (Keeling) Islands</option>
                  <option value="CO">Colombia</option>
                  <option value="KM">Comoros</option>
                  <option value="CG">Congo</option>
                  <option value="CD">Congo, the Democratic Republic of the</option>
                  <option value="CK">Cook Islands</option>
                  <option value="CR">Costa Rica</option>
                  <option value="CI">C&ocirc;te d'Ivoire</option>
                  <option value="HR">Croatia</option>
                  <option value="CU">Cuba</option>
                  <option value="CY">Cyprus</option>
                  <option value="CZ">Czech Republic</option>
                  <option value="DK">Denmark</option>
                  <option value="DJ">Djibouti</option>
                  <option value="DM">Dominica</option>
                  <option value="DO">Dominican Republic</option>
                  <option value="EC">Ecuador</option>
                  <option value="EG">Egypt</option>
                  <option value="SV">El Salvador</option>
                  <option value="GQ">Equatorial Guinea</option>
                  <option value="ER">Eritrea</option>
                  <option value="EE">Estonia</option>
                  <option value="ET">Ethiopia</option>
                  <option value="FK">Falkland Islands (Malvinas)</option>
                  <option value="FO">Faroe Islands</option>
                  <option value="FJ">Fiji</option>
                  <option value="FI">Finland</option>
                  <option value="FR">France</option>
                  <option value="GF">French Guiana</option>
                  <option value="PF">French Polynesia</option>
                  <option value="TF">French Southern Territories</option>
                  <option value="GA">Gabon</option>
                  <option value="GM">Gambia</option>
                  <option value="GE">Georgia</option>
                  <option value="DE">Germany</option>
                  <option value="GH">Ghana</option>
                  <option value="GI">Gibraltar</option>
                  <option value="GR">Greece</option>
                  <option value="GL">Greenland</option>
                  <option value="GD">Grenada</option>
                  <option value="GP">Guadeloupe</option>
                  <option value="GU">Guam</option>
                  <option value="GT">Guatemala</option>
                  <option value="GG">Guernsey</option>
                  <option value="GN">Guinea</option>
                  <option value="GW">Guinea-Bissau</option>
                  <option value="GY">Guyana</option>
                  <option value="HT">Haiti</option>
                  <option value="HM">Heard Island and McDonald Islands</option>
                  <option value="VA">Holy See (Vatican City State)</option>
                  <option value="HN">Honduras</option>
                  <option value="HK">Hong Kong</option>
                  <option value="HU">Hungary</option>
                  <option value="IS">Iceland</option>
                  <option value="IN">India</option>
                  <option value="ID">Indonesia</option>
                  <option value="IR">Iran, Islamic Republic of</option>
                  <option value="IQ">Iraq</option>
                  <option value="IE">Ireland</option>
                  <option value="IM">Isle of Man</option>
                  <option value="IL">Israel</option>
                  <option value="IT">Italy</option>
                  <option value="JM">Jamaica</option>
                  <option value="JP">Japan</option>
                  <option value="JE">Jersey</option>
                  <option value="JO">Jordan</option>
                  <option value="KZ">Kazakhstan</option>
                  <option value="KE">Kenya</option>
                  <option value="KI">Kiribati</option>
                  <option value="KP">Korea, Democratic People's Republic of</option>
                  <option value="KR">Korea, Republic of</option>
                  <option value="KW">Kuwait</option>
                  <option value="KG">Kyrgyzstan</option>
                  <option value="LA">Lao People's Democratic Republic</option>
                  <option value="LV">Latvia</option>
                  <option value="LB">Lebanon</option>
                  <option value="LS">Lesotho</option>
                  <option value="LR">Liberia</option>
                  <option value="LY">Libyan Arab Jamahiriya</option>
                  <option value="LI">Liechtenstein</option>
                  <option value="LT">Lithuania</option>
                  <option value="LU">Luxembourg</option>
                  <option value="MO">Macao</option>
                  <option value="MK">Macedonia, the former Yugoslav Republic of</option>
                  <option value="MG">Madagascar</option>
                  <option value="MW">Malawi</option>
                  <option value="MY">Malaysia</option>
                  <option value="MV">Maldives</option>
                  <option value="ML">Mali</option>
                  <option value="MT">Malta</option>
                  <option value="MH">Marshall Islands</option>
                  <option value="MQ">Martinique</option>
                  <option value="MR">Mauritania</option>
                  <option value="MU">Mauritius</option>
                  <option value="YT">Mayotte</option>
                  <option value="MX">Mexico</option>
                  <option value="FM">Micronesia, Federated States of</option>
                  <option value="MD">Moldova, Republic of</option>
                  <option value="MC">Monaco</option>
                  <option value="MN">Mongolia</option>
                  <option value="ME">Montenegro</option>
                  <option value="MS">Montserrat</option>
                  <option value="MA">Morocco</option>
                  <option value="MZ">Mozambique</option>
                  <option value="MM">Myanmar</option>
                  <option value="NA">Namibia</option>
                  <option value="NR">Nauru</option>
                  <option value="NP">Nepal</option>
                  <option value="NL">Netherlands</option>
                  <option value="AN">Netherlands Antilles</option>
                  <option value="NC">New Caledonia</option>
                  <option value="NZ">New Zealand</option>
                  <option value="NI">Nicaragua</option>
                  <option value="NE">Niger</option>
                  <option value="NG">Nigeria</option>
                  <option value="NU">Niue</option>
                  <option value="NF">Norfolk Island</option>
                  <option value="MP">Northern Mariana Islands</option>
                  <option value="NO">Norway</option>
                  <option value="OM">Oman</option>
                  <option value="PK">Pakistan</option>
                  <option value="PW">Palau</option>
                  <option value="PS">Palestinian Territory, Occupied</option>
                  <option value="PA">Panama</option>
                  <option value="PG">Papua New Guinea</option>
                  <option value="PY">Paraguay</option>
                  <option value="PE">Peru</option>
                  <option value="PH">Philippines</option>
                  <option value="PN">Pitcairn</option>
                  <option value="PL">Poland</option>
                  <option value="PT">Portugal</option>
                  <option value="PR">Puerto Rico</option>
                  <option value="QA">Qatar</option>
                  <option value="RE">R&eacute;union</option>
                  <option value="RO">Romania</option>
                  <option value="RU">Russian Federation</option>
                  <option value="RW">Rwanda</option>
                  <option value="BL">Saint Barth&eacute;lemy</option>
                  <option value="SH">Saint Helena, Ascension and Tristan da Cunha</option>
                  <option value="KN">Saint Kitts and Nevis</option>
                  <option value="LC">Saint Lucia</option>
                  <option value="MF">Saint Martin (French part)</option>
                  <option value="PM">Saint Pierre and Miquelon</option>
                  <option value="VC">Saint Vincent and the Grenadines</option>
                  <option value="WS">Samoa</option>
                  <option value="SM">San Marino</option>
                  <option value="ST">Sao Tome and Principe</option>
                  <option value="SA">Saudi Arabia</option>
                  <option value="SN">Senegal</option>
                  <option value="RS">Serbia</option>
                  <option value="SC">Seychelles</option>
                  <option value="SL">Sierra Leone</option>
                  <option value="SG">Singapore</option>
                  <option value="SK">Slovakia</option>
                  <option value="SI">Slovenia</option>
                  <option value="SB">Solomon Islands</option>
                  <option value="SO">Somalia</option>
                  <option value="ZA">South Africa</option>
                  <option value="GS">South Georgia and the South Sandwich Islands</option>
                  <option value="ES">Spain</option>
                  <option value="LK">Sri Lanka</option>
                  <option value="SD">Sudan</option>
                  <option value="SR">Suriname</option>
                  <option value="SJ">Svalbard and Jan Mayen</option>
                  <option value="SZ">Swaziland</option>
                  <option value="SE">Sweden</option>
                  <option value="CH">Switzerland</option>
                  <option value="SY">Syrian Arab Republic</option>
                  <option value="TW">Taiwan, Province of China</option>
                  <option value="TJ">Tajikistan</option>
                  <option value="TZ">Tanzania, United Republic of</option>
                  <option value="TH">Thailand</option>
                  <option value="TL">Timor-Leste</option>
                  <option value="TG">Togo</option>
                  <option value="TK">Tokelau</option>
                  <option value="TO">Tonga</option>
                  <option value="TT">Trinidad and Tobago</option>
                  <option value="TN">Tunisia</option>
                  <option value="TR">Turkey</option>
                  <option value="TM">Turkmenistan</option>
                  <option value="TC">Turks and Caicos Islands</option>
                  <option value="TV">Tuvalu</option>
                  <option value="UG">Uganda</option>
                  <option value="UA">Ukraine</option>
                  <option value="AE">United Arab Emirates</option>
                  <option value="GB">United Kingdom</option>
                  <option value="US">United States</option>
                  <option value="UM">United States Minor Outlying Islands</option>
                  <option value="UY">Uruguay</option>
                  <option value="UZ">Uzbekistan</option>
                  <option value="VU">Vanuatu</option>
                  <option value="VE">Venezuela, Bolivarian Republic of</option>
                  <option value="VN">Viet Nam</option>
                  <option value="VG">Virgin Islands, British</option>
                  <option value="VI">Virgin Islands, U.S.</option>
                  <option value="WF">Wallis and Futuna</option>
                  <option value="EH">Western Sahara</option>
                  <option value="YE">Yemen</option>
                  <option value="ZM">Zambia</option>
                  <option value="ZW">Zimbabwe</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="field is-horizontal">
        <div class="field-label">
          <label class="label">Platform</label>
        </div>
        <div class="field-body">
          <div class="field is-narrow">
            <div class="control">
              <label class="radio">
                <input type="radio" name="platform" :value="'In-App'" v-model="platform">
                In-App
              </label>
              <label class="radio">
                <input type="radio" name="platform" :value="'Mobile-Web'" v-model="platform">
                Mobile-Web
              </label>
              <label class="radio">
                <input type="radio" name="platform" :value="'Desktop'" v-model="platform">
                Desktop
              </label>
            </div>
          </div>
        </div>
      </div>

      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label">Format</label>
        </div>
        <div class="field-body">
          <div class="field">
            <p class="control is-expanded">
              <typeahead placeholder="Format" v-model="format" :values="formats"/>
            </p>
            <p v-if="formatMessage != null" class="help">{{ formatMessage }}</p>
          </div>
        </div>
      </div>

      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label">Assets</label>
        </div>
        <div class="field-body">
          <div class="field">
            <p class="control is-expanded">
              <input class="input" type="url" v-model="vimeoURL" placeholder="Vimeo URL">
            </p>
          </div>
          <div class="field">
            <p class="control is-expanded">
              <input class="inputfile" type="file" name="file" id="file" @change="fileChange">
              <label class="button is-primary is-fullwidth" for="file">
                {{ filename ? `File: ${filename}` : 'Choose Thumbnail' }}
              </label>
            </p>
          </div>
        </div>
      </div>

      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label"></label>
        </div>
        <div class="field-body">
          <div class="field">
            <p class="control">
              <button class="button is-primary" :class="isLoading ? 'is-loading' : ''" :disabled="!validated">Submit</button>
            </p>
          </div>
        </div>
      </div>

      <p v-if="isSuccess || isError" class="help" :class="isSuccess ? 'is-success' : 'is-error'">{{ isSuccess ? 'Success' : 'Error' }}</p>

    </div>
  </form>
</template>

<script>
import Typeahead from '@/components/Typeahead';
import utils from '@/utils';

export default {
  name: 'Admin',
  components: {
    Typeahead,
  },
  data() {
    return {
      creative: '',
      advertisers: [],
      advertiser: '',
      advertiserMessage: null,
      categories: {},
      category: null,
      country: null,
      platform: null,
      formats: [],
      format: '',
      formatMessage: null,
      vimeoURL: '',
      file: null,
      filename: null,
      isLoading: false,
      isSuccess: false,
      isError: false,
    };
  },
  computed: {
    categoriesArray() {
      return Object.keys(this.categories).sort().map(key => this.categories[key]);
    },
    validated() {
      return !!this.creative &&
        !!this.advertiser &&
        !!this.category &&
        !!this.country &&
        !!this.platform &&
        !!this.format &&
        !!this.vimeoURL &&
        !!this.file;
    },
  },
  watch: {
    format(newFormat) {
      if (newFormat && !this.formats.includes(newFormat)) {
        this.formatMessage = `The format: "${newFormat}" will be added to the database`;
      } else {
        this.formatMessage = null;
      }
    },
    advertiser(newAdvertiser) {
      if (newAdvertiser && !this.advertisers.includes(newAdvertiser)) {
        this.advertiserMessage = `The advertiser: "${newAdvertiser}" will be added to the database`;
      } else {
        this.advertiserMessage = null;
      }
    },
  },
  methods: {
    fileChange(event) {
      const fileInput = event.target;
      const filename = fileInput.value.split(/(\\|\/)/g).pop();
      this.filename = filename;
      this.file = fileInput.files[0];
    },
    onSubmit() {
      this.isLoading = true;

      // The creative object pushed on firebase
      const creative = {
        title: this.creative,
        category: this.category,
        country: this.country,
        platform: this.platform,
        format: this.format,
        vimeoURL: this.vimeoURL,
      };

      const uploadImage = () => {
        // Upload the image
        const storage = firebase.storage().ref();
        const images = storage.child(`images/${utils.uuid()}`);

        return images.put(this.file)
          .then(snapshot => (creative.imageURL = snapshot.downloadURL));
      };

      const createAdvertiser = () => {
        if (this.advertisers.includes(this.advertiser)) {
          creative.advertiser = this.advertiser;
          return Promise.resolve();
        }

        const advertisers = firebase.database().ref('advertisers/');
        const advertiser = advertisers.push();

        return advertiser.set(this.advertiser)
          .then(() => (creative.advertiser = this.advertiser));
      };

      const createFormat = () => {
        if (this.formats.includes(this.format)) {
          creative.format = this.format;
          return Promise.resolve();
        }

        const formats = firebase.database().ref('formats/');
        const format = formats.push();

        return format.set(this.format)
          .then(() => (creative.format = this.format));
      };

      const createCreative = () => {
        const creatives = firebase.database().ref('creatives/');
        const creativeRef = creatives.push();

        return creativeRef.set(creative);
      };

      uploadImage()
        .then(createAdvertiser)
        .then(createFormat)
        .then(createCreative)
        .then(() => {
          this.isLoading = false;
          this.isSuccess = true;
        })
        .catch(() => {
          this.isLoading = false;
          this.isError = true;
        });
    },
  },
  mounted() {
    // Get advertisers
    firebase.database().ref('/advertisers').once('value')
      .then((snapshot) => {
        const advertisers = snapshot.val();
        if (!advertisers) { return; }
        this.advertisers = Object.keys(advertisers).map(key => advertisers[key]).sort();
      });

    // Get categories
    firebase.database().ref('/iab-categories').once('value')
      .then((snapshot) => {
        const categories = snapshot.val();
        if (!categories) { return; }
        this.categories = categories;
      });

    // Get formats
    firebase.database().ref('/formats').once('value')
      .then((snapshot) => {
        const formats = snapshot.val();
        if (!formats) { return; }
        this.formats = Object.keys(formats).map(key => formats[key]).sort();
      });
  },
};
</script>

<style scoped>
  form {
    margin-top: 40px;
  }

  .label, .radio, .help {
    color: #FFF;
  }

  .inputfile {
    width: 0.1px;
    height: 0.1px;
    opacity: 0;
    overflow: hidden;
    position: absolute;
    z-index: -1;
  }
</style>



// WEBPACK FOOTER //
// Admin.vue?d8ab8b62